import { Injectable } from '@angular/core';
import { ReceiptTypeCodes } from '@checkout-v2/const';
import { ReceiptTypeFacade } from '@checkout-v2/data-access';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReceiptService {
  receiptTypes$ = this.receiptTypeFacade.getReceiptTypes();
  activeReceiptTypeId$ = this.receiptTypeFacade.getActiveReceiptTypeId();

  constructor(private receiptTypeFacade: ReceiptTypeFacade) {}

  getActiveReceiptTypeId(): Observable<ReceiptTypeCodes | undefined> {
    return this.activeReceiptTypeId$;
  }

  setActiveReceiptType(code: ReceiptTypeCodes): void {
    this.receiptTypeFacade.setActiveReceiptType(code);
  }
}
